import * as Settings from '@/repositories/Settings'
import { getGlobalCountrySettingsFromCMS } from '@/repositories/cms'

export const settings = {
  namespaced: true,

  state: () => ({
    settings: undefined,
    modals: {
      isConfirmNavigationModal: false,
      isSwitchCountryModal: false
    },
    globalCountrySettings: undefined
  }),

  mutations: {
    setSettings (state, _settings) {
      state.settings = _settings
    },

    setGlobalCountrySettings (state, _settings) {
      state.globalCountrySettings = _settings
    },

    toggleConfirmNavigationModal (state) {
      state.modals.isConfirmNavigationModal =
        !state.modals.isConfirmNavigationModal
    },

    toggleSwitchCountryModal (state) {
      state.modals.isSwitchCountryModal =
        !state.modals.isSwitchCountryModal
    }
  },

  actions: {
    async getSettings ({ commit }, country) {
      const settingsData = await Settings.findByCountryCode(country ? country.toUpperCase() : undefined)
      commit('setSettings', settingsData)
    },

    async fetchGlobalCountrySettings ({ commit }) {
      const { data, error } = await getGlobalCountrySettingsFromCMS()

      if (!error) {
        commit('setGlobalCountrySettings', data)
      }
    },

    async updateSettings ({ commit }, payload) {
      const { countryCode } = payload
      const settingsData = await Settings.findByCountryCode(countryCode)
      commit('setSettings', settingsData)
    },

    toggleConfirmNavigationModal ({ commit }) {
      commit('toggleConfirmNavigationModal')
    },

    toggleSwitchCountryModal ({ commit }) {
      commit('toggleSwitchCountryModal')
    }
  },

  getters: {
    settings (state) {
      return state.settings
    },

    country (state) {
      if (!state.settings) {
        return null
      }

      return state.settings.country
    },

    getConfirmNavigationStatus (state) {
      return state.modals.isConfirmNavigationModal
    },

    getSwitchCountryModalStatus (state) {
      return state.modals.isSwitchCountryModal
    },

    getSettingMobileSupportedCurrentCountry (state) {
      const mobileSupportedSettings =
        state.globalCountrySettings?.settings_v2?.find(
          (item) => item.key === 'MOBILE_SUPPORTED_COUNTRIES'
        )
      const countryCode = state.settings?.country?.code?.toUpperCase()

      return mobileSupportedSettings?.value?.[countryCode]
    }
  }
}
